import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken, setSpotsTaken] = useState(75);
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 58,
    s: 36
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
        return {
          h: Math.floor(seconds / 3600),
          m: Math.floor(seconds % 3600 / 60),
          s: seconds % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = window.setInterval(() => setSpotsTaken(current => Math.min(current + 1, 94)), 45000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const time = `${format(timeLeft.h)}:${format(timeLeft.m)}:${format(timeLeft.s)}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/40 bg-brand-green text-white shadow-md" data-id="element-299" data-mp="27frlyq7jxjjs">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-300" data-mp="22mf1ms9wnywu">
        <div className="hidden items-center justify-center gap-5 text-sm font-medium md:flex" data-id="element-301" data-mp="1xodjc9kb03mf">
          <div className="flex items-center gap-2 text-brand-goldLight" data-id="element-302" data-mp="1sqbzvniyu2af"><Clock className="h-4 w-4" data-id="element-303" data-mp="1snqwuv6xlgb3" /><span data-id="element-304" data-mp="2qdc0p4glr1qo">PRECIO DE LANZAMIENTO CIERRA EN:</span><span className="rounded bg-white/15 px-2 py-0.5 font-mono font-bold tabular-nums text-white" data-id="element-305" data-mp="2qc99swja4zar">{time}</span></div>
          <span className="h-4 w-px bg-white/25" data-id="element-306" data-mp="2lcel8zmz8lsv" />
          <span data-id="element-307" data-mp="2gemtq6q8v1p7"><strong className="text-brand-goldLight" data-id="element-308" data-mp="2ged2ygxdkqig">{spotsTaken}%</strong> de cupos tomados</span>
          <a href="#pricing" className="rounded-full bg-brand-gold px-3 py-1 text-xs font-bold text-brand-navy transition-colors hover:bg-white" data-id="element-309" data-mp="2ceku0342kick">VER KIT →</a>
        </div>
        <div className="relative overflow-hidden md:hidden" data-id="element-310" data-mp="10yw3j1rlx170">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-311" data-mp="10xcofehosw6t">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-312" data-mp="sgu57tkmn32k"><span data-id="element-313" data-mp="sjq1ldgttjow">⏰ Cierra en <strong data-id="element-314" data-mp="xgqadw5290jp">{time}</strong></span><span data-id="element-315" data-mp="xfxc7jk63jd6">•</span><span data-id="element-316" data-mp="xfp03tvvci31"><strong className="text-brand-goldLight" data-id="element-317" data-mp="xff5fszvpmr0">{spotsTaken}%</strong> de cupos tomados</span><a href="#pricing" className="rounded-full bg-brand-gold px-2.5 py-1 text-brand-navy" data-id="element-318" data-mp="jp21e1q3ys6y">VER KIT →</a></React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}